import { COINIS_LOGO_DARK } from '../../config';
import { CodeDisplayer } from '../../pages/login/components/CodeDisplayer';
import { CodeInput } from '../../pages/login/components/CodeInput';

interface MfaStepProps {
  variant: 'qr' | 'code';
  mfaLink?: string;
  email?: string;
  isLoading: boolean;
  error?: string | string[] | null;
  onComplete: (code: string) => Promise<void>;
  onBack: () => void;
}

export const MfaStep = ({
  variant,
  mfaLink,
  email,
  isLoading,
  error,
  onComplete,
  onBack
}: MfaStepProps): JSX.Element => {
  if (variant === 'qr') {
    return (
      <>
        <img src={COINIS_LOGO_DARK} className="h-7 w-auto" alt="Coinis" />
        <div className="flex flex-col gap-[11px]">
          <h1 className="font-onboarding-1 text-[1.625rem] font-bold leading-[1.1] tracking-[-0.02em] text-primary">
            Set up two-factor authentication
          </h1>
          <p className="text-[15px] leading-[1.5] text-[var(--ink-2)]">
            Scan the QR code with your authenticator app, then enter the generated code to complete setup.
          </p>
        </div>
        <CodeDisplayer mfaLink={mfaLink ?? ''} />
        <CodeInput onComplete={onComplete} isMfaSetup={true} onBack={onBack} isLoading={isLoading} error={error} />
      </>
    );
  }

  return (
    <>
      <img src={COINIS_LOGO_DARK} className="h-7 w-auto" alt="Coinis" />
      <div className="flex flex-col gap-[11px]">
        <h1 className="font-onboarding-1 text-[1.625rem] font-bold leading-[1.1] tracking-[-0.02em] text-primary">
          Two-factor authentication
        </h1>
        <p className="text-[15px] leading-[1.5] text-[var(--ink-2)]">
          Enter the 6-digit code from your authenticator app{email ? ` for ${email}` : ''}.
        </p>
      </div>
      <CodeInput onComplete={onComplete} isMfaSetup={false} onBack={onBack} isLoading={isLoading} error={error} />
    </>
  );
};
